<template>
  <div class="login flex-box col">
    <div class="flex-box-bd">
      <div class="topList">
        <myDropdown
          class="f14 langs"
          :list="$config.langs"
          v-model="lang"
          key_name="val"
          value_name="key"
          @onChange="langBoxClick"
        ></myDropdown>
      </div>
    </div>
    <div class="tcenter">
      <div class="flex-box">
        <div class="flex-box-bd"></div>
        <div class="login-box">
          <div class="flex-box nopadding">
            <div class="flex-box nopadding">
              <img class="login_logo" :src="login_logo" />
            </div>
            <div class="bg-white logolist">
              <div class="mg-top30 flex-box nopadding">
                <div class="flex-box-bd"></div>
                <div>
                  <img class="img-80" :src="ed_logo" />
                </div>
                <!-- <div class="f-bd f30" style="color:#00a0e9">{{$t('sys_name2')}}</div> -->
                <div class="flex-box-bd"></div>
              </div>
              <div class="f-blue f25 mg-top10">{{$t('pwd_login')}}</div>
              <div class="mg-top10 tleft f18">{{$t('ID')}}{{$t('x_mh')}}</div>
              <div class="mg-top5 f16">
                <input
                  v-model="formData.user_code"
                  class="fillw pd-5 my-input"
                  :placeholder="$t('input_code')"
                />
              </div>
              <div class="mg-top30 tleft f18">{{$t('PWD')}}{{$t('x_mh')}}</div>
              <div class="mg-top5 f16">
                <input
                  v-model="formData.user_pwd"
                  class="fillw pd-5 my-input"
                  type="password"
                  :placeholder="$t('input_pwd')"
                  @keyup="pwdKeyup"
                />
              </div>
              <Button
                class="round-20 mg-top30"
                type="primary"
                @click="login"
                long
                size="large"
              >{{ $t("btn_submit") }}</Button>
            </div>
          </div>
        </div>
        <div class="flex-box-bd"></div>
      </div>
    </div>
    <div class="flex-box-bd"></div>
    <!-- <div class="tcenter f14 f-white mg-bottom10">{{$t('sys_code')}} {{$t('sys_sn')}}</div> -->
    <div class="tcenter f14 f-white mg-bottom10">@2022 Ed Connect</div>
  </div>
</template>

<script>
import myDropdown from '@/components/myDropdown'
export default {
  name: "login",
  components: {
    myDropdown
  },
  data () {
    return {
      login_logo: require("@/assets/img/login_logo.png"),
      ed_logo: require("@/assets/img/ed_logo.png"),
      lang: this.$base.getLang(),
      img_path: this.$config.imgUrl,
      formData: {
        user_code: "",
        user_pwd: ""
      }
    }
  },
  mounted () {
    document.title = this.$t('sys_name');
  },
  methods: {
    langBoxClick (data) {
      this.$base.setLangCookie(this, data.key);
    },
    pwdKeyup ($e) {
      if ($e.keyCode == 13) {
        this.login();
      }
    },
    login (e) {
      //this.$base.getRole();return;
      var user_code = this.formData.user_code;
      if (user_code == "") {
        this.$base.alertInfo(this.$t('input_code'));
        return;
      }
      var user_pwd = this.formData.user_pwd;
      if (user_pwd == "") {
        this.$base.alertInfo(this.$t('input_pwd'));
        return;
      }
      this.formData.user_pwd = this.$base.toMD5(this.formData.user_pwd);
      this.$base.showLoading();
      this.$request.sendPost("user/login", this.formData, (success, data, error) => {
        this.$base.hideLoading();
        this.formData.user_pwd = "";
        if (success) {
          this.$base.setTokenCookie(data);
        }
        else {
          this.$base.alertErr(error.errmsg);
        }
      });
    }
  }
}
</script>

<style lang="less" scoped>
.login {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-image: url('https://jclm-imgs.oss-cn-zhangjiakou.aliyuncs.com/ui/back/login/bg.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-color: #00255b;
}
/deep/ .topList {
  display: flex;
  justify-content: right;
  padding: 10px;
  .f-green {
    color: #fff !important;
  }
}

.login-box {
  //   background-image: -webkit-linear-gradient(top, #0075df, #0044bd);
  .login_logo {
    height: 490px;
    border-radius: 10px 0 0 10px;
  }
  .logolist {
    width: 400px;
    height: 490px;
    padding: 0 80px;
    border-radius: 0 10px 10px 0;
  }
}
.my-input {
  outline: none;
  border-top: 0;
  border-left: 0;
  border-right: 0;
  border-bottom: solid 1px #222;
}
.my-input:focus {
  color: #0081ff;
  border-bottom: solid 1px #0081ff;
}
</style>



// WEBPACK FOOTER //
// src/pages/login.vue